import { DayRangeFilter } from 'features/insights/components/compare-bar/report-actions-bar/advance-filters-modal/filters/day-range-filter';
import { APP_CONSTS } from 'core/constants/app-consts';
import { DateFilter } from './filters/date-range-filter/date-range-filter';
import { HoursRangeFilter } from './filters/hours-range-filter/hours-range-filter';
import { AudienceTypeFilter } from 'features/insights/components/compare-bar/report-actions-bar/advance-filters-modal/filters/audience-type-filter';
import { FilterOperator, FilterType } from '@placer-ui/types';
import { FilterConfig } from 'features/insights/types/filter-types';
import { MultiOptionsFilterComponent } from 'features/insights/components/compare-bar/report-actions-bar/advance-filters-modal/multi-entities-filter/types';
import {
    VisitDurationFilter,
    // eslint-disable-next-line max-len
} from 'features/insights/components/compare-bar/report-actions-bar/advance-filters-modal/filters/visit-duration-filter/visit-duration-filter';
import { getPermissions } from 'core/flow-control';

type ModalFilterConfig = {
    label: string;
    FilterComponent: MultiOptionsFilterComponent;
    type: FilterType;
    defaultFilter?: FilterConfig;
};

export const getAudienceFilter = () => {
    const { enable_visit_frequency_filter_on_property } = getPermissions();
    return [
        {
            label: enable_visit_frequency_filter_on_property ? 'Audience Type:' : 'Include:',
            FilterComponent: AudienceTypeFilter,
            type: APP_CONSTS.filter.attributions.keys.AUDIENCE_TYPE,
            defaultFilter: {
                operator: APP_CONSTS.filter.operators.IN,
                value: ['visitors'],
            },
        },
    ] as ModalFilterConfig[];
};

export const timeSectionFilters = [
    {
        label: 'Date range:',
        FilterComponent: DateFilter,
        type: 'date',
    },
    {
        label: 'Day range:',
        FilterComponent: DayRangeFilter,
        type: APP_CONSTS.filter.attributions.keys.DAYS_OF_WEEK,
        defaultFilter: {
            operator: APP_CONSTS.filter.operators.IN,
            value: [0, 1, 2, 3, 4, 5, 6],
        },
    },
    {
        label: 'Hours range:',
        FilterComponent: HoursRangeFilter,
        type: APP_CONSTS.filter.attributions.keys.TIME_OF_DAY,
        defaultFilter: {
            operator: APP_CONSTS.filter.operators.BETWEEN,
            value: ['00:00-23:59'],
        },
    },
    {
        label: 'Visit Duration:',
        FilterComponent: VisitDurationFilter,
        type: APP_CONSTS.filter.attributions.keys.LENGTH_OF_STAY,
        defaultFilter: {
            operator: null,
            value: 50,
        },
    },
] as ModalFilterConfig[];

export const VISITS_FREQUENCY_DEFAULT_FILTER = {
    operator: APP_CONSTS.filter.operators.MORE_THEN_OR_EQUAL as FilterOperator,
    value: 1,
};